import { HotelInfoModel } from '@/__generated';
import HotelJapaneseName from '@/components/App/Hotels/HotelJapaneseName';
import { formatDateOnly } from '@/config';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

type Props = {
  hotelInfo: HotelInfoModel;
};
const wheelchairIcon = require('@/assets/icons/facilities/wheelchair.png');
const elevatorIcon = require('@/assets/icons/facilities/elevator.png');
export default function BuildingInfo({ hotelInfo }: Props) {
  if (!hotelInfo.hotelBuildings?.length) {
    return null;
  }
  return (
    <div id="hotel-buildings" className="row y-gap-40 pt-20 pb-20 ">
      <div className="col-12">
        <h3 className="text-22 fw-500 pt-30">Hotel buildings</h3>
        <div className="row x-gap-10 y-gap-10 mt-20">
          {hotelInfo.hotelBuildings?.map((building, index) => {
            return (
              <div className="col-md-4 col-xs-12" key={index}>
                <div className="p-4 rounded text-15 h-100 border-light">
                  <div className=" border-bottom-light px-5 pb-5 fw-500 text-center">
                    <span>
                      {building.buildingNameEn}
                      <HotelJapaneseName name={building.buildingName} addBefore="-" />
                    </span>
                  </div>

                  <div className="row x-gap-10">
                    {building.noOfFloors ? (
                      <>
                        <div className="d-flex justify-between pt-10 ">
                          <div className="text-14 ml-5">
                            <i className="ficon  ficon-top-floor text-16 mr-5"></i> No of floors
                          </div>
                          <div className="text-14 fw-500">{building.noOfFloors} floors</div>
                        </div>
                      </>
                    ) : null}
                    {building?.noOfRooms ? (
                      <>
                        <div className="d-flex justify-between pt-10 ">
                          <div className="text-14 ml-5">
                            <i className="ficon  ficon-number-of-rooms text-16 mr-5"></i> No of rooms
                          </div>
                          <div className="text-14 fw-500">{building.noOfRooms} rooms</div>
                        </div>
                      </>
                    ) : null}
                    {building.capacity ? (
                      <div className="d-flex justify-between pt-10 ">
                        <div className="text-14 ml-5">
                          <i className="ficon ficon-regular-capacity text-16 mr-5"></i> Capacity
                        </div>
                        <div className="text-14 fw-500">{building.capacity} people</div>
                      </div>
                    ) : null}
                    {building?.dateOfBuilding ? (
                      <>
                        <div className="d-flex justify-between pt-10 ">
                          <div className="text-14 ml-5">
                            <i className="ficon  ficon-year-hotel-built text-16 mr-5"></i> Date of building
                          </div>
                          <div className="text-14 fw-500">{formatDateOnly(building.dateOfBuilding)}</div>
                        </div>
                      </>
                    ) : null}

                    {building.bfBuildingEntrance ? (
                      <div className="d-flex justify-between pt-10 ">
                        <div className="text-14 d-flex items-center">
                          <img src={wheelchairIcon} style={{ width: 22, height: 22, marginRight: 7 }} />
                          <span className="text-15 text-blue-1" id={'Barrier-free-entrance-building-' + index}>
                            Barrier-free entrance
                          </span>
                          <UncontrolledTooltip target={'Barrier-free-entrance-building-' + index}>
                            Passing by a wheelchair smoothly(no steps, enough width and hard to slip)
                          </UncontrolledTooltip>
                        </div>
                        <div className="text-14 fw-500">
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        </div>
                      </div>
                    ) : null}
                    {building.bfCorridor ? (
                      <div className="d-flex justify-between pt-10">
                        <div className="text-14 d-flex items-center">
                          <img src={wheelchairIcon} style={{ width: 22, height: 22, marginRight: 7 }} />
                          Corridor
                        </div>
                        <div className="text-15 text-blue-1">
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        </div>
                      </div>
                    ) : null}
                    {building.bfToilet ? (
                      <div className="d-flex justify-between pt-10">
                        <div className="text-14 d-flex items-center">
                          <img src={wheelchairIcon} style={{ width: 22, height: 22, marginRight: 7 }} />
                          Barrier-free toilet
                        </div>
                        <div className="text-15 text-blue-1">
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        </div>
                      </div>
                    ) : null}
                    {building.bfWheelChairToilet ? (
                      <div className="d-flex justify-between pt-10">
                        <div className="text-14 d-flex items-center">
                          <img src={wheelchairIcon} style={{ width: 22, height: 22, marginRight: 7 }} />
                          Toilet can be used with wheelchair
                        </div>
                        <div className="text-15 text-blue-1">
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        </div>
                      </div>
                    ) : null}
                    {building.bfWheelChairElevator ? (
                      <div className="d-flex justify-between pt-10">
                        <div className="text-14 d-flex items-center">
                          <img src={elevatorIcon} style={{ width: 22, height: 22, marginRight: 7 }} />
                          [Elevator] The wheelchair can pass smoothly
                        </div>
                        <div className="text-15 text-blue-1">
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        </div>
                      </div>
                    ) : null}

                    {building.bfWheelChairControllerElevator ? (
                      <div className="d-flex justify-between pt-10">
                        <div className="text-14 d-flex items-center">
                          <img src={elevatorIcon} style={{ width: 22, height: 22, marginRight: 7 }} />
                          [Elevator] Controller that can be operated by the height of the wheelchair
                        </div>
                        <div className="text-15 text-blue-1">
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        </div>
                      </div>
                    ) : null}
                    {building.bfHandrailElevator ? (
                      <div className="d-flex justify-between pt-10">
                        <div className="text-14 d-flex items-center">
                          <img src={elevatorIcon} style={{ width: 22, height: 22, marginRight: 7 }} />
                          Elevator with handrail
                        </div>
                        <div className="text-15 text-blue-1">
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
